import { IReferenceData } from 'src/app/shared/interfaces/form/reference-data.model';

export class ScheduleTimeRequestModel {
  [key: string]: unknown;
  sessionType: IReferenceData;
  providerAgency: IReferenceData;
  serviceType: IReferenceData;
  evaluationType: IReferenceData;
  evaluatorName: string;
  evaluatorTitle: string;
  evaluatorPhone: string;
  evaluatorEmail: string;
  studentName: string;
  language: IReferenceData;
  groupSize: string;
  makeupSession: boolean;
  startDate: string | Date;
  startTime: string | Date;
  endTime: string | Date;
  occurences: IReferenceData;
  occurencesCount: number;
  weekDayChip: number[];
  monthlyOption: boolean;
  dayCount: number;
  yearlyOption: boolean;
  monthOfYear: IReferenceData;
  weekOrder: IReferenceData;
  weekDay: IReferenceData;
  monthOfYearAlt: IReferenceData;
  repeatUntil: IReferenceData;
  repeatUntilCount: number;
  endByDate: string | Date;
  studentMandates: any;
  locationType: IReferenceData;
  location: string;
  floorRoom: string;
  teamsMeeting: boolean;
  minutes: string;
  additionalInfo: string;
  dragedStartDate?: string | Date;
  dragedStartTime?: string | Date;
  dragedEndTime?: string | Date;
  requiredAttendees: any[];
  optionalAttendees: any[];
  trainingDescription: string;
  submission: boolean;
  students: any[];
  parentSK: string;
  studentSk: string;
  nycId: string;
  meetingSk: string;
  addSelectionToGroup: boolean;
  selectedMandatesDetails: any;
  recurringMeetingSk: string;
  start?: string | Date;
  end?: string | Date;
  user?: unknown;
  getMeetingDetails?: boolean;
  selecteStudentdMandates?: unknown;
  selectedMandates?: unknown;
  constructor(data: Partial<ScheduleTimeRequestModel> = {}) {
    // Reference data
    this.sessionType = data.sessionType ?? null;
    this.providerAgency = data.providerAgency ?? null;
    this.serviceType = data.serviceType ?? null;
    this.language = data.language ?? null;

    // Primitives
    this.groupSize = data.groupSize ?? '';
    this.makeupSession = data.makeupSession ?? false;

    // Dates (convert string → Date)
    this.startDate = data.startDate
      ? new Date(data.dragedStartDate ?? data.startDate)
      : null;
    this.startTime = data.startTime
      ? new Date(data.dragedStartTime ?? data.startTime)
      : null;
    this.endTime = data.endTime
      ? new Date(data.dragedEndTime ?? data.endTime)
      : null;
    this.endByDate = data.endByDate ? new Date(data.endByDate) : null;

    // Other fields
    this.occurences = data.occurences ?? null;
    this.occurencesCount = data.occurencesCount ?? null;
    this.weekDayChip = data.weekDayChip ?? [];
    this.monthlyOption = data.monthlyOption ?? false;
    this.dayCount = data.dayCount ?? null;
    this.yearlyOption = data.yearlyOption ?? false;
    this.monthOfYear = data.monthOfYear ?? null;
    this.weekOrder = data.weekOrder ?? null;
    this.weekDay = data.weekDay ?? null;
    this.monthOfYearAlt = data.monthOfYearAlt ?? null;
    this.repeatUntil = data.repeatUntil ?? null;
    this.repeatUntilCount = data.repeatUntilCount ?? null;
    this.recurringMeetingSk = data.recurringMeetingSk ?? null;
    if (data.addSelectionToGroup) {
      const mergedData: any[] = [
        ...(data?.selectedMandatesDetails ?? []),
        ...(data?.studentMandates ?? [])
      ];
      this.studentMandates = mergedData ?? null;

    } else {
      this.studentMandates = data.studentMandates ?? null;

    }
    this.locationType = data.locationType ?? null;
    this.location = data.location ?? '';
    this.floorRoom = data.floorRoom ?? '';
    this.teamsMeeting = data.teamsMeeting ?? false;
    this.minutes = data.minutes ?? '';
    this.additionalInfo = data.additionalInfo ?? '';
    this.students = data.students ?? [];
    this.requiredAttendees = data.requiredAttendees ?? [];
    this.optionalAttendees = data.optionalAttendees ?? [];
    this.trainingDescription = data.trainingDescription ?? '';
    this.submission = data.submission ?? null;
    this.evaluationType = data.evaluationType ?? null;
    this.evaluatorName = data.evaluatorName ?? null;
    this.evaluatorTitle = data.evaluatorTitle ?? null;
    this.evaluatorPhone = data.evaluatorPhone ?? null;
    this.evaluatorEmail = data.evaluatorEmail ?? null;
    this.parentSK = data.parentSK ?? null;
    this.studentSk = data.studentSk ?? null;
    this.nycId = data.nycId ?? null;
    this.meetingSk = data.meetingSk ?? null;
  }
}